import { ExecutionEnvironmentUtils } from "@gt/common-utils/build/general/ExecutionEnvironmentUtils";

export function hasNavigator(): boolean {
  return ExecutionEnvironmentUtils.isBrowser() && !(navigator?.geolocation == null);
}
